// @ts-strict-ignore
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {FilterClause} from 'common/report/insights/models/filter-clause';
import {FilterSection} from 'common/report/insights/models/section';
import {DETERMINER_MAPPING} from 'common/report/insights/util/constants';
import {FiltersOperator} from 'common/query-builder/query-entry-section/types';
import {findKeyByValue} from 'common/util/typescript';
import {reporter} from 'common/report/error-reporting';

import {FilterDeterminer} from './types';

/**
 * Transforms FilterSection clauses to propertyFilters
 */
export function getPropertyFilters(filterClauses: FilterClause[]): PropertyFilter[] {
  return (filterClauses ?? []).map((clause) => clause.toPropertyFilter());
}

/** A hack to ensure bookmark filters are good.
 *
 * We've had some errors around bookmark filters being an object instead of an
 * array. The `getPropertyFiltersFromBookmark` function is not well typed, and
 * neither is the top level parts where the bookmark filters come from. This
 * function help avoid errors around this.
 *
 * @deprecated Do not use this function anywhere else without understanding it's
 * a hack. If you are removing this, also make sure to go up the stack wherever
 * `getPropertyFiltersFromBookmark` is used and make sure it's correctly typed
 * and it will get an array of bookmark filters.
 */
function normalizePropertyFiltersFromBookmark(bookmarkFilters: TODO): TODO {
  if (Array.isArray(bookmarkFilters)) {
    return bookmarkFilters;
  }

  if (
    typeof bookmarkFilters === `object` &&
    bookmarkFilters &&
    `clauses` in bookmarkFilters &&
    Array.isArray(bookmarkFilters.clauses)
  ) {
    return bookmarkFilters.clauses.filter((clause: TODO) => `filterType` in clause);
  }

  reporter.error(`Invalid bookmark filters`, bookmarkFilters);
  throw new Error(`Invalid bookmark filters`);
}

export function getPropertyFiltersFromBookmark(bookmarkFilters: TODO): PropertyFilter[] {
  return normalizePropertyFiltersFromBookmark(bookmarkFilters).map((filter) =>
    new FilterClause(filter).toPropertyFilter(),
  );
}

export function getPropertyFiltersOperator(determiner: FilterDeterminer): FiltersOperator {
  return findKeyByValue(DETERMINER_MAPPING, determiner);
}

/**
 * Transforms propertyFilters to FilterSection
 */
export function getFilterSection(
  filters: Array<Partial<PropertyFilter>>,
  filterOperator: FiltersOperator,
): FilterSection {
  const clauses = (filters ?? []).map((item) => FilterClause.fromPropertyFilter(item));
  const determiner = DETERMINER_MAPPING[filterOperator];

  return new FilterSection({
    clauses,
    determiner,
  });
}
